import { localize2WithPath } from 'vscode/vscode/vs/nls';
import { registerAction2, Action2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { CHAT_CATEGORY } from 'vscode/vscode/vs/workbench/contrib/chat/browser/actions/chatActions';
import { IChatWidgetService } from 'vscode/vscode/vs/workbench/contrib/chat/browser/chat.service';
import { CONTEXT_IN_CHAT_SESSION, CONTEXT_CHAT_ENABLED } from 'vscode/vscode/vs/workbench/contrib/chat/common/chatContextKeys';
import { isResponseVM } from 'vscode/vscode/vs/workbench/contrib/chat/common/chatViewModel';

const _moduleId = "vs/workbench/contrib/chat/browser/actions/chatFileTreeActions";
function registerChatFileTreeActions() {
    registerAction2(class NextFileTreeAction extends Action2 {
        constructor() {
            super({
                id: 'workbench.action.chat.nextFileTree',
                title: ( localize2WithPath(_moduleId, 0, "Next File Tree")),
                keybinding: {
                    primary: 2048  | 67 ,
                    weight: 200 ,
                    when: CONTEXT_IN_CHAT_SESSION,
                },
                precondition: CONTEXT_CHAT_ENABLED,
                f1: true,
                category: CHAT_CATEGORY,
            });
        }
        run(accessor, ...args) {
            navigateTrees(accessor, false);
        }
    });
    registerAction2(class PreviousFileTreeAction extends Action2 {
        constructor() {
            super({
                id: 'workbench.action.chat.previousFileTree',
                title: ( localize2WithPath(_moduleId, 1, "Previous File Tree")),
                keybinding: {
                    primary: 2048  | 1024  | 67 ,
                    weight: 200 ,
                    when: CONTEXT_IN_CHAT_SESSION,
                },
                precondition: CONTEXT_CHAT_ENABLED,
                f1: true,
                category: CHAT_CATEGORY,
            });
        }
        run(accessor, ...args) {
            navigateTrees(accessor, true);
        }
    });
}
function navigateTrees(accessor, reverse) {
    const chatWidgetService = accessor.get(IChatWidgetService);
    const widget = chatWidgetService.lastFocusedWidget;
    if (!widget) {
        return;
    }
    const focused = !widget.inputEditor.hasWidgetFocus() && widget.getFocus();
    const focusedResponse = isResponseVM(focused) ? focused : undefined;
    const currentResponse = focusedResponse ?? widget.viewModel?.getItems().reverse().find((item) => isResponseVM(item));
    if (!currentResponse) {
        return;
    }
    widget.reveal(currentResponse);
    const responseFileTrees = widget.getFileTreeInfosForResponse(currentResponse);
    const lastFocusedFileTree = widget.getLastFocusedFileTreeForResponse(currentResponse);
    const focusIdx = lastFocusedFileTree ?
        (lastFocusedFileTree.treeIndex + (reverse ? -1 : 1) + responseFileTrees.length) % responseFileTrees.length :
        reverse ? responseFileTrees.length - 1 : 0;
    responseFileTrees[focusIdx]?.focus();
}

export { registerChatFileTreeActions };
